export const environment = {
    production: false,
    api: 'https://precalc-backend-dev.adf.andritz.com',
    msalConfig: {
        auth: {
            clientId: '9def5d69-7a9c-4571-aaba-eab6a7039b90',
            authority: 'https://login.microsoftonline.com/6785298f-e857-464b-9b4b-807178402632',
            redirectUri: 'https://precalc-dev.adf.andritz.com',
        },
    },
    apiADConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me',
    },
    apiConfig: {
        scopes: ['api://9def5d69-7a9c-4571-aaba-eab6a7039b90/User.Read'],
        uri: 'https://graph.microsoft.com/v1.0/me',
    },
    syncFusionConfig: {
        apiKey: 'Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXhceXRcRmhdVkd2WUVWYEE=',
    },
};